import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';


@Component({
	selector: 'workflow-visual-notification',
	template: '<div #display></div>',
})
export class VisualNotificationComponent implements AfterViewInit {

	@ViewChild('display')
	display: ElementRef<HTMLElement>;

	private _active: boolean;
	private startTime: number | undefined;

	// Gemessene Verzögerung zwischen ButtonPress und Reaktion auf dem Bildschirm
	// wir gehen davon aus, dass die Verzögerung beim  Anzeigen des Kreises die gleiche ist, wie
	// beim Ausblenden des Kreises. Dadurch konnte  die Eingabe- und Ausgabeverzögerung per
	// Video gemessen werden. Je nach Monitor muss evtl noch eine zusätzliche Kalibrierung
	// stattfinden.
	ioDelay = 100;

	ngAfterViewInit(): void {
		this.active = false;
	}

	get active(): boolean {
		return this._active;
	}

	set active(value: boolean) {
		this._active = value;
		this.display.nativeElement.parentElement.style.visibility = value ? 'visible' : 'hidden';
		this.startTime = value ? performance.now() : undefined;
	}

	duration(eventTimestamp: number): number | undefined {
		if (this.active && eventTimestamp) {
			const duration = eventTimestamp - this.startTime - this.ioDelay;
			return duration;
		}
		return undefined;
	}


	deactivate(eventTimestamp?: number): number | undefined {
		if (this.active) {
			const duration = this.duration(eventTimestamp);
			this.active = false;
			return duration;
		}
	}
}
